export const ID = '335055f5-4898-49b1-9771-e3eba57fed23';

export const NAME = 'Leave a Review Button';
